<template>
    <form method="POST" :action="route" @submit="checkForm">
        <input type="hidden" name="_token" :value="token">
            <div class="row justify-content-center mx-auto">
                <table class="myfotable">
                    <thead style="border-bottom: none;">
                        <tr v-for="(position, index) in pos" :key="index">
                            <th class="text-left font-weight-bold fts-14 pl-3" v-if="position.arbitrage_show" :rowspan="position.arbitrage_row_span" style="color:rgb(38, 42, 62); width:100%; background-color:rgba(38, 42, 62, .05);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search mr-2" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                </svg>
                                L'analyse myfo : {{ position.arbitrage }}
                            </th>
                        </tr>
                    </thead>
                </table>
                <table class="myfotable">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 20%;" class="text-left pl-3">
                                <div style="display: inline-block;"> 
                                    Secteur
                                </div>
                                <div style="display: inline-block;">
                                    <button
                                        style="text-align:center;"
                                        type="button"
                                        id="sort"
                                        class="fas fa-caret-up"
                                        aria-label="Tri ascendant"
                                        v-on:click="sectorSortAsc">
                                    </button>
                                </div>
                                <div style="display: inline-block;">
                                    <button
                                        style="text-align:center"
                                        type="button"
                                        id="sort"
                                        class="fas fa-caret-down"
                                        aria-label="Tri descendant"
                                        v-on:click="sectorSortDsc">
                                    </button>
                                </div>
                            </th>
                            <th class="text-left" scope="col" style="width: 25%;">Nom</th>
                            <th scope="col" style="width: 15%;">Allocation actuelle ({{positions.slice(-1).pop().security.currency.symbol}})</th>
                            <th scope="col" style="width: 15%;">Nouvelle allocation ({{positions.slice(-1).pop().security.currency.symbol}})</th>
                            <th scope="col" style="width: 15%;">Nouvelle allocation (%)</th>
                            <th scope="col" style="width: 15%;">Différence</th>
                        </tr>
                    </thead>
                    <tbody class="fts-12" v-for="(position, index) in pos" :key="index">
                        <tr v-if="position.cash == 0">
                            <td style="width:15%;" class="font-weight-bold text-left pl-3">
                                {{ position.sector }}
                            </td>
                            <td class="text-left" style="width:25%;">
                                <div class="font-weight-bold" style="text-transform:uppercase;">{{ position.name }}</div>
                                <div class="pt-1" style="font-size:10px; color: #6E7389;">Code ISIN : {{ position.isin }}</div>
                                <div class="pt-1 font-weight-bold" style="font-size: 10px; color: rgb(62, 105, 214);">
                                    <span style="padding: 3px; border-radius: 10px; background-color: rgba(62, 105, 214,.1);">{{ position.asset_class }}</span>
                                </div>
                            </td>
                            <td style="width:15%;">
                            {{  Math.round(position.previous_nominal_value_base,0) }}
                            </td>
                            <td style="width:10%;" class="font-weight:bold;">
                                <input
                                    type="number"
                                    class="waiting"
                                    step="0.01"
                                    :name="'form[' + position.id + '][nominal_value_base]'"
                                    v-model="position.nominal_value_base_rounded"
                                    @change="onNominalChange"
                                    :style="position.sell==1?'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(253, 180, 75,.1); color:rgb(253, 180, 75); border-radius:10px':'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(19, 178, 44, .1); color:rgb(19, 178, 44); border-radius:10px'">
                                <input type="hidden" :name="'form[' + position.id + '][number_shares]'" :value="position.nominal_value_base_rounded * 100">
                            </td>
                            <td style="width:10%;" class="font-weight:bold;">
                                <input
                                    type="number"
                                    class="waiting"
                                    step="0.01"
                                    :name="'form[' + position.id + '][percentage]'"
                                    v-model="position.percentage_rounded"
                                    @change="onPercentageChange"
                                    :style="position.sell==1?'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(253, 180, 75,.1); color:rgb(253, 180, 75); border-radius:10px':'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(19, 178, 44, .1); color:rgb(19, 178, 44); border-radius:10px'">
                                <input type="hidden" :name="'form[' + position.id + '][percentage]'" :value="position.percentage_rounded * 100">
                            </td>
                            <td class="font-weight-bold" style="width:10%;">
                                {{ Math.round(position.nominal_value_base - position.previous_nominal_value_base,0) }}
                            </td>
                        </tr>
                        <tr v-else>
                            <td class="text-left py-5">
                                <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-block;" class="mr-2">
                                    <path fill-rule="evenodd" d="M9.11.43a55.3 55.3 0 0113.78 0 10 10 0 018.68 8.68 55.5 55.5 0 010 13.78 10 10 0 01-8.68 8.68 55.3 55.3 0 01-13.78 0 10 10 0 01-8.68-8.68 55.32 55.32 0 010-13.78A10 10 0 019.11.43z" fill="rgba(107, 90, 237,.1)"></path>
                                    <path fill-rule="evenodd" d="M17.53 12.33c-.45 0-.64-.7-1.09-.7s-.64.7-1.1.7-.63-.7-1.09-.7-.56.48-.87.64a.43.43 0 01-.22.06c-.46 0-.64-.7-1.1-.7s-.64.7-1.09.7-.64-.7-1.09-.7V23c.45 0 .63-.71 1.09-.71s.64.71 1.09.71.64-.71 1.1-.71.64.71 1.09.71.64-.71 1.09-.71.64.71 1.1.71.64-.71 1.09-.71.64.71 1.09.71V11.63c-.45 0-.62.7-1.09.7zM15.16 16v.86H12.8a2 2 0 000 .34 1.76 1.76 0 000 .34h2.36v.87h-2c.07.08.14.17.22.25a2.06 2.06 0 001.44.6 2.09 2.09 0 001.46-.61l.73.73a3.08 3.08 0 01-2.19.91 2.88 2.88 0 01-1.44-.37A3.07 3.07 0 0112 18.41h-.93v-.87h.72a3.18 3.18 0 010-.34v-.34h-.72V16H12a3 3 0 011.4-1.51 2.88 2.88 0 011.44-.37A3.12 3.12 0 0117 15l-.73.74a2 2 0 00-1.46-.61 2 2 0 00-1.44.6 2.62 2.62 0 00-.22.25zM21 9.77c-.45 0-.64-.77-1.09-.77s-.64.77-1.1.77S18.2 9 17.75 9s-.64.77-1.09.77S16 9 15.56 9s-.64.77-1.09.77S13.83 9 13.38 9v2.12a1.3 1.3 0 01.87-.34 1.44 1.44 0 011.09.55 1.37 1.37 0 012.19 0 1.46 1.46 0 011.09-.55h.84v10.16a.65.65 0 00.48.31c.45 0 .64-.77 1.09-.77s.64.77 1.09.77V9c-.45 0-.63.77-1.09.77" fill="rgb(107, 90, 237)"></path>
                                </svg>
                                <p class="fts-14 font-weight-bold mb-0 text-left" style="color: #6B5AED; display:inline-block;">Ajustement de vos arbitrages en cash</p>
                                <a href="#" data-toggle="modal" data-target="#positionname" style="display: inline-block;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#6B5AED" class="bi bi-info-circle ml-2" viewBox="0 0 16 16" style="margin-bottom:2px;">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                    </svg>
                                </a>
                                <div class="modal fade" id="positionname" tabindex="-1" role="dialog" aria-labelledby="uploadModal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="MentionsLegalesModal"> {{ position.name}}</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="display:none">
                                <input
                                    type="number"
                                    step="0.01"
                                    :name="'form[' + position.id + '][nominal_value_base]'"
                                    v-model="position.nominal_value_base_rounded"
                                    @change="onNominalChange"
                                    :style="position.sell==1?'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(253, 180, 75,.1); color:rgb(253, 180, 75); border-radius:10px':'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(19, 178, 44, .1); color:rgb(19, 178, 44); border-radius:10px'">
                                <input type="hidden" :name="'form[' + position.id + '][number_shares]'" :value="position.nominal_value_base_rounded * 100">
                            </td>
                            <td style="display:none">
                                <input
                                    type="number"
                                    step="0.01"
                                    :name="'form[' + position.id + '][percentage]'"
                                    v-model="position.percentage_rounded"
                                    @change="onPercentageChange"
                                    :style="position.sell==1?'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(253, 180, 75,.1); color:rgb(253, 180, 75); border-radius:10px':'width:50%!important; text-align:center; font-weight:bold; border:none!important; background-color:rgba(19, 178, 44, .1); color:rgb(19, 178, 44); border-radius:10px'">
                                <input type="hidden" :name="'form[' + position.id + '][percentage]'" :value="position.percentage_rounded * 100">
                            </td>
                            <td style="color: #6B5AED;">
                                <div class="font-weight-bold fts-14" style="display: inline-block;">
                                    Mouvement du cash :
                                </div>
                                <div class="font-weight-bold fts-14" style="display: inline-block;">
                                    {{Math.round(position.nominal_value_base - position.previous_nominal_value_base,0)}} €
                                </div>
                            </td>
                            <td>
                                <div class="text-right">
                                    <strong>Écart</strong>
                                </div>
                                <div class="pt-2 text-right">
                                    <strong>Total</strong>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <strong>{{ Math.round(gap_amount,0) }}</strong>
                                </div>
                                <div class="pt-2">
                                    <strong>{{ Math.round(total,0) }}</strong>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <strong>{{ gap_percentage }}</strong>
                                </div>
                                <div class="pt-2">
                                    <strong>100%</strong>
                                </div>
                            </td>
                            <td>
                                <button
                                    v-if="position.cash=='1'"
                                    type="button"
                                    class="btn-myfo-purple"
                                    style=""
                                    v-on:click="adjust(position)"
                                    :disabled="valid">
                                    Ajuster
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-6 mx-auto justify-content-center text-center my-3">
                <button type="submit" class="btn-myfo-blue" :disabled="!valid">Valider</button>
            </div>

    </form>
</template>

<script>
    export default {
        props: [
            'positions',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                errors: [],
                total: 0,
                gap_amount: 0,
                gap_percentage: 0,
                pos: [],
                valid: true,

            }
        },


        mounted() {

            this.positions.forEach(position =>
            {
                this.total += position.nominal_value_base
            });
            this.total = Math.round(this.total * 100) / 100;
            this.positions.forEach(position =>
            {
                this.pos.push(
                {
                    arbitrage_show: true,
                    arbitrage_row_span: 1,
                    arbitrage: position.arbitrage.rational,
                    id: position.id,
                    name: position.security.name,
                    isin: position.security.isin,
                    asset_class: position.security.asset_class.name_french,
                    sector: position.security.sector.name_french,
                    date: position.last_trade_date,
                    previous_nominal_value_base: position.previous_nominal_value_base,
                    nominal_value_base: position.nominal_value_base_recommended,
                    nominal_value_base_rounded: Math.round(position.nominal_value_base_recommended * 100) / 100,
                    percentage: position.nominal_value_base_recommended / this.total * 100,
                    percentage_rounded: Math.round(position.nominal_value_base_recommended / this.total * 100 * 100) / 100,
                    sell: position.sell,
                    cash: position.cash,
                });
            });

            var i;
            var ref = 0;
            var arbitrage = "";
            for (i = 0 ; i < this.pos.length ; i++){
                if (this.pos[i].arbitrage == arbitrage)
                {
                    this.pos[i].arbitrage_show = false;
                    this.pos[ref].arbitrage_row_span++;
                }
                else
                {
                    ref = i;
                    arbitrage = this.pos[i].arbitrage;
                }
            }
        },

        methods: {
            onNominalChange(){
                this.gap_amount = this.total;
                this.gap_percentage = 100;
                this.pos.forEach(position =>
                {
                    position.nominal_value_base = position.nominal_value_base_rounded;

                    position.percentage = position.nominal_value_base / this.total * 100;
                    position.percentage_rounded = Math.round(position.percentage_rounded * 100) / 100;

                    this.gap_amount = this.gap_amount - position.nominal_value_base;
                    this.gap_percentage = this.gap_percentage - position.percentage;
                });
                this.gap_amount = Math.round(this.gap_amount * 100) / 100;
                this.gap_percentage = Math.round(this.gap_percentage * 100) / 100;
                this.valid = this.gap_amount == 0 && this.gap_percentage == 0;
            },

            onPercentageChange(){
                this.gap_amount = this.total;
                this.gap_percentage = 100;
                this.pos.forEach(position =>
                {
                    position.percentage = position.percentage_rounded;

                    position.nominal_value_base = position.percentage / 100 * this.total;
                    position.nominal_value_base_rounded = Math.round(position.nominal_value_base * 100) / 100;

                    this.gap_amount = this.gap_amount - position.nominal_value_base;
                    this.gap_percentage = this.gap_percentage - position.percentage;
                });
                this.gap_amount = Math.round(this.gap_amount * 100) / 100;
                this.gap_percentage = Math.round(this.gap_percentage * 100) / 100;
                this.valid = this.gap_amount == 0 && this.gap_percentage == 0;
            },

            adjust(cash_position) {

                var gap = this.total;
                this.pos.forEach(position =>
                {
                    if (position != cash_position)
                    {
                        gap -= position.nominal_value_base;
                    }
                });
                cash_position.nominal_value_base_rounded = gap;
                if (cash_position.nominal_value_base_rounded < 0)
                {
                    cash_position.nominal_value_base_rounded = 0;
                }
                this.onNominalChange();
            },

            checkForm(event){
                if (!valid)
                {
                    event.preventDefault()
                }
            },

            sectorSortAsc(){

                this.pos = this.pos.sort(function(a, b){
                    if (a.cash < b.cash)
                    {
                        return -1;
                    }
                    else if (a.cash > b.cash)
                    {
                        return 1;
                    }
                    else if (a.sector < b.sector)
                    {
                        return -1;
                    }
                    else if (a.sector > b.sector)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            sectorSortDsc(){
                this.pos = this.pos.sort(function(a, b){
                    if (a.cash < b.cash)
                    {
                        return -1;
                    }
                    else if (a.cash > b.cash)
                    {
                        return 1;
                    }
                    else if (a.sector > b.sector)
                    {
                        return -1;
                    }
                    else if (a.sector < b.sector)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
        }
    }
</script>
